export const dateFormat = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
};
//# sourceMappingURL=locale.js.map